import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import CheckBox from 'components/CheckBox';
import SimpleInput from 'components/SimpleInput';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../../reducers';
import PhaseType from 'types/phase';

class InstallerPreWalkthrough extends Resetter(Validator(React.Component)) {
  state = {
    installerParkedInStreet: this.props.installerParkedInStreet || false,
    installerDrivewayPermission: this.props.installerDrivewayPermission || false,
    installerProtectFromOil: this.props.installerProtectFromOil || false,
    installerCarpetSeamPlacement: this.props.installerCarpetSeamPlacement || false,
    installerCarpetSeamVisibility: this.props.installerCarpetSeamVisibility || false,
    installerHardSurfaceMoistureReadings: this.props.installerHardSurfaceMoistureReadings || false,
    installerActualReading: this.props.installerActualReading || '',
    errors: {},
  };

  installerPreWalkthroughRef = React.createRef();

  componentDidMount = () => this.installerPreWalkthroughRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { installerParkedInStreet, installerDrivewayPermission, installerProtectFromOil,
      installerCarpetSeamPlacement, installerCarpetSeamVisibility,
      installerHardSurfaceMoistureReadings, installerActualReading } = this.state;
    this.props.updateFormData({
      installerParkedInStreet,
      installerDrivewayPermission,
      installerProtectFromOil,
      installerCarpetSeamPlacement,
      installerCarpetSeamVisibility,
      installerHardSurfaceMoistureReadings,
      installerActualReading,
      tab: 3,
    });
  }

  handlePrevious = () => {
    const { installerParkedInStreet, installerDrivewayPermission, installerProtectFromOil,
      installerCarpetSeamPlacement, installerCarpetSeamVisibility,
      installerHardSurfaceMoistureReadings, installerActualReading } = this.state;
    this.props.updateFormData({
      installerParkedInStreet,
      installerDrivewayPermission,
      installerProtectFromOil,
      installerCarpetSeamPlacement,
      installerCarpetSeamVisibility,
      installerHardSurfaceMoistureReadings,
      installerActualReading,
      tab: 1,
    });
  }

  handleInstallerParkedInStreet = () =>
    this.setState({ installerParkedInStreet: !this.state.installerParkedInStreet });

  handleInstallerDrivewayPermission = () =>
    this.setState({ installerDrivewayPermission: !this.state.installerDrivewayPermission });

  handleInstallerProtectFromOil = () =>
    this.setState({ installerProtectFromOil: !this.state.installerProtectFromOil });

  handleInstallerCarpetSeamPlacement = () =>
    this.setState({ installerCarpetSeamPlacement: !this.state.installerCarpetSeamPlacement });

  handleInstallerCarpetSeamVisibility = () =>
    this.setState({ installerCarpetSeamVisibility: !this.state.installerCarpetSeamVisibility });

  handleInstallerHardSurfaceMoistureReadings = () =>
    this.setState({
      installerHardSurfaceMoistureReadings: !this.state.installerHardSurfaceMoistureReadings,
    });

  handleInstallerActualReading = e => this.setState({ installerActualReading: e.target.value });

  render = () => {
    const { isSpanish } = this.props;
    const {
      installerParkedInStreet,
      installerDrivewayPermission,
      installerProtectFromOil,
      installerCarpetSeamPlacement,
      installerCarpetSeamVisibility,
      installerHardSurfaceMoistureReadings,
      installerActualReading,
      errors,
    } = this.state;

    return (<div>
      <h6 ref={this.installerPreWalkthroughRef}>
        {isSpanish ? 'Lista de Verificación del Instalador' : 'Installer Checklist'}
      </h6>
      <CheckBox
        required
        text={isSpanish
          ? 'Estacioné en la calle'
          : 'I parked in the street'
        }
        errors={errors.installerParkedInStreet}
        onChange={this.handleInstallerParkedInStreet}
        checked={installerParkedInStreet}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'Pedí permiso para usar la entrada'
          : 'I asked permission to use the driveway'
        }
        errors={errors.installerDrivewayPermission}
        onChange={this.handleInstallerDrivewayPermission}
        checked={installerDrivewayPermission}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'Protegí el camino de entrada del petróleo'
          : 'I protected the driveway from oil'
        }
        errors={errors.installerProtectFromOil}
        onChange={this.handleInstallerProtectFromOil}
        checked={installerProtectFromOil}
      />
      {this.props.surfaceType && this.props.surfaceType.toLowerCase() === 'carpet' ? (
        <span>
          <CheckBox
            required
            text={isSpanish
              ? 'He revisado la colocación de la costura con el cliente'
              : 'I have reviewed seam placement with the customer'
            }
            errors={errors.installerCarpetSeamPlacement}
            onChange={this.handleInstallerCarpetSeamPlacement}
            checked={installerCarpetSeamPlacement}
          />
          <CheckBox
            required
            text={isSpanish
              ? 'He discutido la visibilidad de la costura'
              : 'I have discussed seam visibility'
            }
            errors={errors.installerCarpetSeamVisibility}
            onChange={this.handleInstallerCarpetSeamVisibility}
            checked={installerCarpetSeamVisibility}
          />
        </span>
      ) : (
        <CheckBox
          required
          text={isSpanish
            ? 'He tomado medido de humedad'
            : 'I have taken moisture readings'
          }
          errors={errors.installerHardSurfaceMoistureReadings}
          onChange={this.handleInstallerHardSurfaceMoistureReadings}
          checked={installerHardSurfaceMoistureReadings}
        />
      )}
      {installerHardSurfaceMoistureReadings && <SimpleInput
        label={isSpanish
          ? 'Medición de Humedad'
          : 'Moisture Reading'
        }
        required
        text={installerActualReading}
        errors={errors.installerActualReading}
        onChange={this.handleInstallerActualReading}
      />}
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

InstallerPreWalkthrough.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  surfaceType: PropTypes.string,
  installerParkedInStreet: PropTypes.bool,
  installerDrivewayPermission: PropTypes.bool,
  installerProtectFromOil: PropTypes.bool,
  installerCarpetSeamPlacement: PropTypes.bool,
  installerCarpetSeamVisibility: PropTypes.bool,
  installerHardSurfaceMoistureReadings: PropTypes.bool,
  installerActualReading: PropTypes.string,
  errors: PropTypes.shape({
    installerParkedInStreet: PropTypes.arrayOf(PropTypes.string),
    installerDrivewayPermission: PropTypes.arrayOf(PropTypes.string),
    installerProtectFromOil: PropTypes.arrayOf(PropTypes.string),
    installerCarpetSeamPlacement: PropTypes.arrayOf(PropTypes.string),
    installerCarpetSeamVisibility: PropTypes.arrayOf(PropTypes.string),
    installerHardSurfaceMoistureReadings: PropTypes.arrayOf(PropTypes.string),
    installerActualReading: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(InstallerPreWalkthrough);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/pre/installerPreWalkthrough.jsx